/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellValueUnion } from "./CellValueUnion";
import { CellValue } from "./CellValue";
export const DiffValue = core.serialization
    .object({
    snapshotValue: CellValueUnion.optional(),
    clipValue: CellValueUnion.optional(),
    warning: core.serialization.boolean().optional(),
    warnings: core.serialization.list(core.serialization.string()).optional(),
})
    .extend(CellValue);
